export function getDisabledModuleFacilityRedirectPath({
  isReady,
  isEnabled,
  gridPath,
}: {
  isReady: boolean;
  isEnabled: boolean;
  gridPath: string | undefined;
}): string | null {
  if (!isReady || isEnabled || !gridPath) {
    return null;
  }
  return gridPath;
}
